<template>
  <article class="referral-status-box">
    <p class="referral-status-box__title">
      <strong>{{ title.emphasis }}</strong> {{ title.normal }}
      <popover 
        v-show="popoverMessage"
        :placement="'bottom'"
      >
        <span v-html="popoverMessage" />
      </popover>
    </p>
    <p 
      v-show="subTitle"
      class="referral-status-box__subtitle"
    >
      {{ subTitle }}
    </p>
    <section class="referral-status-box__bottom"> 
      <p 
        class="referral-status-box__cnt"
      >
        {{ cnt + cntFormat }}
      </p>
      <button 
        class="referral-status-box__btn"
        v-show="event"
        @click="event ? event() : ()=>{}"
      >
        더 알아보기
      </button>
    </section>
  </article>
</template>
<script>
import Popover from '@/components/popover';

export default {
  name : 'ReferralStatusViewBox',
  components : { Popover },
  props : {
    boxTitle: {
      type: Object,
      default() {
        return {
          emphasis: undefined,
          normal: undefined,
        };
      },
    },
    boxSubTitle: {
      type: String || undefined,
      default: undefined,
    },
    boxCnt: {
      type: Number,
      default: 0,
    },
    boxCntFormat: {
      type: String,
      default: '명',
    },
    boxPopoverMessage: {
      type: String || undefined,
      default: undefined,
    },
    boxEvent: {
      type: Function || undefined,
      default: undefined,
    },
  },
  computed : {
    title(){
      return this.boxTitle;
    },
    subTitle(){
      return this.boxSubTitle;
    },
    cnt(){
      return this.boxCnt;
    },
    cntFormat(){
      return this.boxCntFormat;
    },
    popoverMessage(){
      return this.boxPopoverMessage;
    },
    event(){
      return this.boxEvent ? this.boxEvent : undefined;
    },
  },
};
</script>

<style lang="scss">
    .referral-status-box{
        position: relative;
        width: 167px;
        height: 90px;
        padding: 12px 15px 12px 15px;
        border-radius: 6px;
        background-color: #ebebeb;
        color: #4a4a4a;
        .referral-status-box__title,
        .referral-status-box__subtitle{
            font-size: 12px;
            margin: 0;
            letter-spacing: -0.5px;
        }

        .referral-status-box__title{
            position: relative;
            span{
                position: absolute;
                right: 0;
            }
        }
        .referral-status-box__bottom{
            display: flex;
            justify-content: space-between;
            width: calc(100% - 30px);
            position: absolute;
            bottom: 12px;
            .referral-status-box__cnt{
                font-size: 18px;
                letter-spacing: -0.72px;
                font-weight: normal;
                margin: auto 0;
            }
    
            .referral-status-box__btn{
                border: none;
                outline: none;
                padding:0;
                text-decoration: underline;
                background-color: inherit;
                font-size: 8px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: -0.33px;
            }
        }

    @media screen and (max-width: 768px) {
      width: calc(50% - 3px);
    }
    }
</style>